import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import { getUrlParams } from "../../utils/actions";

import Agencies from "./Agencies";
import LoginPage from "./LoginPage";

// Login component:
// - handle url token
//      - When token, call external login
//      - Collect agency and other context data
//      - Write token and refresh token to localstorage
// - handle oauth2 token and Agencies display
// - fallback to Login page
class Login extends Component {
  constructor() {
    super();

    this.state = {
      agencies: null,
      token: null,
      refresh: null,
      clientId: null,
      loggedIn: false,
      redirectUrl: "",
    };
  }

  renderRedirect = () => {
    if (this.state.loggedIn) {
      return <Redirect to={this.state.redirectUrl} />;
    }
  };

  renderLogin = () => {
    if (this.state.agencies && this.state.agencies.length > 0) {
      return (
        <Agencies
          clientId={this.state.clientId}
          agencies={this.state.agencies}
          authenticate={() => {
            BACKEND_CONFIG.set("auth", this.state.token);
            BACKEND_CONFIG.set("refresh", this.state.refresh);
          }}
        />
      );
    } else {
      return (
        <LoginPage
          onServerValidationErrors={(e) =>
            this.props.onServerValidationErrors(e)
          }
        />
      );
    }
  };

  UNSAFE_componentWillMount() {
    var params = getUrlParams(this.props.location.search);
    var oauth2token = this.extractToken(params);

    //Necessary for refresh work around. See App.js.
    if (params.clientId) {
      BACKEND_CONFIG.set("clientid", params.clientId);
    }

    if (params.token && params.AgencyId) {
      axios
        .post(
          `${BACKEND_CONFIG.apiUrl}account/external-login`,
          {
            agencyId: params.AgencyId,
            token: params.token,
          },
          {
            headers: {
              Authorization: `Bearer ${params.token}`,
              Pragma: "no-cache",
            },
          }
        )
        // We make the calls to localstorage, which are synchronous
        // but might somtimes actually take a little time to complete
        // leading to a race condition
        .then((response) => {
          if (response.data.Agency) {
            BACKEND_CONFIG.clearAll();
            BACKEND_CONFIG.set("auth", response.data.Token);
            BACKEND_CONFIG.set("refresh", response.data.RefreshToken);
            BACKEND_CONFIG.set("agencyid", response.data.Agency.AgencyId);
          }

          return response;
        })
        // delay a few milliseconds waiting on localstorage
        .then(delay(5))
        // then continue on
        .then((response) => {
          if (response.data.Agencies) {
            this.setState({
              agencies: response.data.Agencies,
              token: response.data.Token,
              refresh: response.RefreshToken,
              clientId: params.clientId,
            });
          }

          if (response.data.Agency) {
            let redirectUrl = !!params.clientId
              ? `/client/${params.clientId}`
              : "/home";

            this.setState({
              loggedIn: true,
              redirectUrl: redirectUrl,
            });
          }
        })
        .catch((error) => {});
    } else if (oauth2token) {
      axios
        .get(`${BACKEND_CONFIG.apiUrl}account/login/agencies`, {
          headers: {
            Authorization: `Bearer ${oauth2token}`,
            Pragma: "no-cache",
          },
        })
        .then((result) =>
          this.setState({ agencies: result.data, token: oauth2token })
        )
        .catch((error) => {});
    }
  }

  render() {
    return (
      <div>
        {this.renderRedirect()}
        {this.renderLogin()}
      </div>
    );
  }

  extractToken(params) {
    var oauth2token = params.oauth2token;

    if (!oauth2token) {
      return null;
    }

    var authResponseString = window.atob(oauth2token);
    return JSON.parse(authResponseString).Token;
  }
}

export default Login;

// delay for specified ms, then forward along the value of the promise
function delay(delayMs) {
  return function (response) {
    return new Promise((resolve) => {
      setTimeout(function () {
        return resolve(response);
      }, delayMs);
    });
  };
}
